// import { getTelegramInitData } from "../../utils/telegram";
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;


class ApiService {
    constructor(baseURL = API_BASE_URL) {
        this.baseURL = baseURL;
    }

    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;

        const response = await fetch(url, {
            credentials: 'include',
            mode: 'cors',
            ...options,
        });

        try {
            return await response.json();
        } catch (_) {
            if (!response.ok) {
                return { success: false, data: null, message: `HTTP error! status: ${response.status}` };
            }
            return { success: true, data: null, message: "OK" };
        }
    }

    async get(endpoint) {
        return this.request(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': `tma ${getTelegramInitData()}`,
            },
        });
    }

    async post(endpoint, data) {
        return this.request(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': `tma ${getTelegramInitData()}`,
            },
            body: JSON.stringify(data),
        });
    }

    // Add other HTTP methods as needed (PUT, DELETE, etc.)
}

const apiInstance = new ApiService();

export default apiInstance;
